import gql from 'graphql-tag';

export const DEAL_NOTE_ACTIVITY_FRAGMENT = gql`
  fragment DealNoteActivityFields on DealNoteActivityViewModel {
    id
    type
    topic
    content
    parentId
    createdDateTime
    updatedDateTime
    participants {
      id
      fullName
      participationType
    }
  }
`;
